import { render, staticRenderFns } from "./PromotionPreviewHeart.vue?vue&type=template&id=7a16c1e9"
import script from "./PromotionPreviewHeart.vue?vue&type=script&lang=js"
export * from "./PromotionPreviewHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports